'use es6';

import { createSelector } from 'reselect';
import { basicSelector, basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
import { Map as ImmutableMap, fromJS } from 'immutable';
import { getModuleLists } from 'ContentEditorUI/redux/selectors/moduleSelectorHelpers';
export const getContentFlexAreaStyleSettings = createSelector([getModuleLists], moduleLists => moduleLists.get('flexAreaStyleSettings'));
const getDefaultSettings = basicSelector(state => state.defaultSettings);
const getDefaultSettingsImmutable = createSelector(getDefaultSettings, defaultSettings => ImmutableMap(defaultSettings));
export const getStyleSettings = createSelector(getContentFlexAreaStyleSettings, styleSettings => styleSettings.filter(style => style !== null));
export const getEffectiveStyleSettings = createSelector([getStyleSettings, getDefaultSettingsImmutable], (styleSettings, defaultSettings) => {
  return defaultSettings.merge(styleSettings);
});
export const getLayoutSettings = createSelector([getModuleLists], moduleLists => moduleLists.get('flexAreaStyles'));
export const getIsSingleColumnFullWidth = createSelector(getLayoutSettings, settings => settings.get('isSingleColumnFullWidth'));
export const getIsBoxedLayout = createSelector(getLayoutSettings, layoutSettings => layoutSettings.get('boxed'));
export const getFlexAreaLayoutType = basicSelector(state => {
  if (getIsBoxedLayout(state)) {
    return 'BOXED';
  }
  if (getIsSingleColumnFullWidth(state)) {
    return 'FULL_WIDTH';
  }
  return 'DEFAULT';
});
export const getBodyBorderWidth = createSelector([getIsBoxedLayout, getEffectiveStyleSettings], (isBoxedLayout, styleSettings) => isBoxedLayout ? parseInt(styleSettings.get('body_border_width', 0), 10) : 0);

// only apply a default when not boxed
export const getDefaultSectionColor = createSelector([getIsBoxedLayout, getEffectiveStyleSettings], (isBoxedLayout, styleSettings) => !isBoxedLayout ? styleSettings.get('body_color') : null);
export const getLayoutPadding = createSelector(getEffectiveStyleSettings, effectiveStyleSettings => {
  return effectiveStyleSettings.get('layout_padding');
});
export const getMobileSettings = createSelector(getEffectiveStyleSettings, effectiveStyleSettings => effectiveStyleSettings.get('mobile_settings'));
export const getMobileLayoutPadding = createSelector(getMobileSettings, mobileSettings => mobileSettings === null || mobileSettings === void 0 ? void 0 : mobileSettings.get('layout_padding'));
export const getConvertedLinkStyleDefault = basicSelectorWithStats(state => {
  const styleSettings = getEffectiveStyleSettings(state);
  return fromJS({
    styles: {
      italic: styleSettings.getIn(['links_font', 'italic']),
      bold: styleSettings.getIn(['links_font', 'bold']),
      underline: styleSettings.getIn(['links_font', 'underline'])
    },
    color: styleSettings.getIn(['links_font', 'color'])
  });
});
export const getIsEmailInitialSourceBrandedTemplate = createSelector(getEffectiveStyleSettings, effectiveStyleSettings => effectiveStyleSettings.get('initial_source') === 'BRANDED_TEMPLATE');